type SharePriceAlertsProps = {
  standard: string;
};
export function SharePriceAlerts({ standard }: SharePriceAlertsProps) {
  return (
    <euroland-tool
      data-tool-name="ShareAlert"
      data-tool-company="98480"
      data-tool-language={standard}
    />
  );
}
